import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Self } from '@angular/core';
import {
  CheckoutCustomerDetailsComponent,
  CheckoutProgressionStepsComponent,
} from '@checkout/feature-components';
import {
  CHECKOUT_CARD_CONFIG,
  CHECKOUT_CONFIG,
  CheckoutCardProvider,
  PAYSAFE_CONFIG,
  WORLDPAY_CONFIG,
} from '@checkout/util-models';
import { BasketSummaryComponent } from '@domgen/dgx-fe-basket';
import { CmsArea } from '@domgen/dgx-fe-cms';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { AddressFormBuilder } from '@domgen/dgx-fe-forms/address';
import { GAPage } from '@domgen/dgx-fe-ga';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { EditableArea } from '@magnolia/angular-editor';
import { PaysafeFormComponent } from '../../components/paysafe-form/paysafe-form.component';
import { WorldpayFormComponent } from '../../components/worldpay-form/worldpay-form.component';
import { checkoutCardConfigFactory } from '../../factories/checkout-card-config-factory/checkout-card-config.factory';
import { paysafeConfigFactory } from '../../factories/paysafe-config-factory/paysafe-config.factory';
import { worldpayConfigFactory } from '../../factories/worldpay-config-factory/worldpay-config.factory';
import { featureCardTranslationDictionaryMapping } from '../../i18n/feature-card-translation-dictionary-mapping.constant';
import { CardComponentService } from '../../services/card-component/card-component.service';
import { WorldpayFormBuilder } from '../../services/worldpay-form-builder/worldpay-form-builder.service';
import { WorldpayService } from '../../services/worldpay/worldpay.service';

@Component({
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  providers: [
    provideTranslationDictionaryMapping(
      featureCardTranslationDictionaryMapping
    ),
    CardComponentService,
    WorldpayService,
    WorldpayFormBuilder,
    AddressFormBuilder,
    {
      provide: CHECKOUT_CARD_CONFIG,
      useFactory: checkoutCardConfigFactory,
      deps: [CHECKOUT_CONFIG],
    },
    {
      provide: PAYSAFE_CONFIG,
      useFactory: paysafeConfigFactory,
      deps: [CHECKOUT_CARD_CONFIG],
    },
    {
      provide: WORLDPAY_CONFIG,
      useFactory: worldpayConfigFactory,
      deps: [CHECKOUT_CARD_CONFIG],
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    GridSectionComponent,
    GridContainerComponent,
    GridRowComponent,
    GridColumnComponent,
    CheckoutProgressionStepsComponent,
    CheckoutCustomerDetailsComponent,
    NgSwitch,
    NgSwitchCase,
    PaysafeFormComponent,
    WorldpayFormComponent,
    BasketSummaryComponent,
    EditableArea,
    AsyncPipe,
  ],
})
@GAPage()
export class CardComponent {
  @Input() main!: CmsArea;

  cardProvider: typeof CheckoutCardProvider = CheckoutCardProvider;

  constructor(@Self() readonly cs: CardComponentService) {}
}
